<template>
  <div
    class="fill-height"
    :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 400px; padding-top: 164px;` : `padding-bottom: 610px; padding-top: 64px;`">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-container>
            <v-row>
              <v-col cols="12" md="9">
                <div class="mb-4 d-flex align-center text-second" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'body-2'">
                  <v-btn text to="/pengumuman " class="text-capitalize px-1" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'body-2'" color="blue">
                    Pengumuman
                  </v-btn>
                  <div class="mr-3 ml-1">
                    .|.
                  </div>
                  <div>
                    Detail Pengumuman
                  </div>
                </div>
                <div v-if="process.load">
                  <v-card
                    flat
                    height="100%"
                    v-if="process.load"
                    :min-height="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? '100vh' : '100vh'"
                    :max-height="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? '100vh' : '100vh'"
                    color="#00000040">
                    <v-skeleton-loader
                      v-if="process.load"
                      :loading="process.load"
                      transition="scale-transition"
                      :tile="false"
                      class="ma-auto load_card_x_large"
                      type="image"
                      style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
                    </v-skeleton-loader>
                  </v-card>
                </div>
                <v-card flat class="pa-5" v-if="!process.load && Object.keys(detail).length > 0">
                  <div v-if="detail.image_url_json.length < 1 && detail.image_url.length > 0">
                    <v-img contain style="border-radius: 6px;" :src="detail.image_url === '' ? '' : detail.image_url"></v-img>
                  </div>
                  <div v-if="detail.image_url_json.length > 0">
                    <!-- <v-img contain :src="detail.image_url === '' ? require('@/assets/image/no-photo.png') : detail.image_url"></v-img> -->
                    <v-carousel height="500" width="100%">
                      <v-carousel-item
                        v-for="(item,i) in detail.image_url_json"
                        :key="i"
                        :src="item.src"
                        contain
                        style="border-radius: 6px;"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                      ></v-carousel-item>
                    </v-carousel>
                  </div>
                  <v-card-title class="text-h5 px-0 mb-2">
                    {{ detail.title }}
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <div>
                      <v-icon
                        size="18">
                        mdi-account-circle-outline
                      </v-icon>
                      <span class="me-1 body-2">JDIH</span>
                      <span class="ml-2">
                        <v-icon
                          size="18">
                          mdi-calendar-range
                        </v-icon>
                        <span class="me-1 body-2"> {{ detail.publish_datetime | date }} </span>
                      </span>
                      <span class="ml-2">
                        <v-icon
                          size="18">
                          mdi-eye
                        </v-icon>
                        <span class="me-1 body-2">Dilihat {{ detail.view_count }} Kali </span>
                      </span>
                    </div>
                    <div class="mt-3 font-weight-regular" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'body-2'" style="font-size: 18px;" v-html="detail.content">
                    </div>
                  </v-card-text>
                  <v-divider class="my-5"></v-divider>
                  <v-avatar
                    v-for="(item, index) in sosmed"
                    :key="index"
                    tile
                    width="50"
                    height="50">
                    <ShareNetwork
                      :network="item.network"
                      :url="`${host}${$route.path}`"
                      :title="detail.title"
                      :description="detail.meta_json.description"
                      hashtags="JDIH,diskominfo">
                      <v-img
                        contain
                        width="40"
                        height="40"
                        alt="JDIH"
                        :src="item.icon">
                      </v-img>
                    </ShareNetwork>
                  </v-avatar>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <Sidebar />
              </v-col>
            </v-row>
          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        dateNow: new Date(),
        detail: {},
        sosmed: [
          { network: 'facebook', icon: require('@/assets/sosmed/ic_share_fb.svg') },
          { network: 'instagram', icon: require('@/assets/sosmed/ic_share_ig.svg') },
          { network: 'twitter', icon: require('@/assets/sosmed/ic_share_tw.svg') },
          { network: 'telegram', icon: require('@/assets/sosmed/ic_share_tel.svg') },
          { network: 'whatsapp', icon: require('@/assets/sosmed/ic_share_wa.svg') }
        ],
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/pengumuman/:slug',
          title: 'Detail Pengumuman',
          description: 'Detail Pengumuman JDIH Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    components: {
      Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
    },
    watch: {

    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      host () {
        return process.env.HOST_NAME
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          title: (this.$route.params.slug.split('-').join(' ').split('=').join('-').split('>').join('/'))
        }

        await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
        .then(response => {
          let res = response

          // this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.fetchDetail()
            if (res.results.data.length < 1 || res.results.data.length > 1) {
              this.fetchDetailbyID()
            }
            // if (this.detail.doc_type_par_id !== '4') {
            //   this.detail.penetapan_date = new Date(this.detail.penetapan_date).getFullYear()
            // }
          }
        })
      },
      async fetchDetailbyID () {
        this.process.load = true

        let params = {
          id: this.$route.query.q
        }

        await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
        .then(response => {
          let res = response

          // this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.fetchDetail()
            if (res.results.data.length < 1 || res.results.data.length > 1) {
              this.process.load = false
            }
            // if (this.detail.doc_type_par_id !== '4') {
            //   this.detail.penetapan_date = new Date(this.detail.penetapan_date).getFullYear()
            // }
          }
        })
      },
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.detail.id
        }

        await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
        .then(response => {
          let res = response

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data[0]
            if (this.detail.image_url_json.length > 0) {
              this.detail.image_url_json = JSON.parse(this.detail.image_url_json)
              this.detail.image_url_json = this.detail.image_url_json.map(item => {
                const container = {};

                container.src = item

                // this.category = container;
                return container
              })
            }
            // this.detail = res.results.data
            // if (this.detail.doc_type_par_id !== '4') {
            //   this.detail.penetapan_date = new Date(this.detail.penetapan_date).getFullYear()
            // }
          }
        })
      },
      // async fetchDetail () {
      //   this.process.load = true

      //   let params = {
      //     id: this.$route.params.slug
      //   }

      //   await this.$axios.$get(`${process.env.API}sites/article/detail`, { params })
      //   .then(response => {
      //     let res = response

      //     this.process.load = false

      //     if (res.status === 200) {
      //       this.detail = res.results.data
      //       this.detail.meta_json = JSON.parse(res.results.data.meta_json)
      //     }
      //   })
      // }
    }
  }
</script>
